import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { LottieAnimationViewModule } from 'ng-lottie';

import { ChooseGameComponent } from './choose-game/choose-game.component';
import { HeaderComponent } from './header/header.component';
import { LeaderBoardComponent } from './leader-board/leader-board.component';
import { TimerComponent } from './timer/timer.component';
import { MatchGameComponent } from './match-game/match-game.component';
import { RailsMapComponent } from './match-game/rails-map/rails-map.component';
import { NewPlayerComponent } from './leader-board/new-player/new-player.component';
import { LeaderBoardListComponent } from './leader-board/leader-board-list/leader-board-list.component';
import { TriviaGameComponent } from './trivia-game/trivia-game.component';
import { GameInfoComponent } from './game-info/game-info.component';
import { GamePlayComponent } from './game-play/game-play.component';
import { InitDirective } from './init.directive';
import { CompleteTheWordDirective } from './complete-the-word.directive';
import { CountDownComponent } from './count-down/count-down.component';
import { TriviaMapComponent } from './trivia-game/trivia-map/trivia-map.component';


registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    ChooseGameComponent,
    HeaderComponent,
    RailsMapComponent,
    LeaderBoardComponent,
    TimerComponent,
    MatchGameComponent,
    NewPlayerComponent,
    LeaderBoardListComponent,
    CountDownComponent,
    TriviaGameComponent,
    GameInfoComponent,
    GamePlayComponent,
    InitDirective,
    CompleteTheWordDirective,
    TriviaMapComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    LottieAnimationViewModule.forRoot()
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [{ provide: NZ_I18N, useValue: en_US }],
  bootstrap: [AppComponent]
})
export class AppModule { }
